import * as actionTypes from './actionTypes';

export const fetchContributionActivityData =(payload) => ({
    type: actionTypes.fetchCADataType,
    payload
 });

  export const updateFilterData = payload =>({
    type: actionTypes.updateFilterDataType,
    payload
  });

  export const getContributionData = payload => ({
    type: actionTypes.fetchDataByIdType,
    payload
  });

  export const clearCurrentContribution = payload => ({
    type: actionTypes.clearContributionType,
    payload
  });

  export const cancelContribution = payload => ({
    type: actionTypes.cancelContributionType,
    payload
  });

  export const replaceWithWholeData = payload => ({
    type: actionTypes.replaceWithWholeDataType,
    payload
  });

  export const resetContribution = payload => ({
    type: actionTypes.resetContributionType,
    payload
   });